export function TableHeading({title}){
    return <p className="text-sm text-blue-dark font-bold font-barlow">{title}</p>
}